import { render, staticRenderFns } from "./EditEmailTemplateModal.vue?vue&type=template&id=5d879ab8"
import script from "./EditEmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./EditEmailTemplateModal.vue?vue&type=style&index=0&id=5d879ab8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports